var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isDebug ? _c('pre', [_vm._v("      " + _vm._s(_vm.debug) + "\n")]) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }